<template>
    <v-navigation-drawer app clipped dark color="blue" v-model="drawer">
        <v-list shaped v-if="profile">
            <v-list-item :to="{name: 'course-index'}" link>
                <v-list-item-icon>
                    <v-icon>mdi-folder</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Курсы ({{profile.summary.courses}})</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'theme-index'}" link>
                <v-list-item-icon>
                    <v-icon>mdi-clipboard-list-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Темы ({{profile.summary.themes}})</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'profile-index'}" link>
              <v-list-item-icon>
                <v-icon>mdi-account-box</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Мой профиль</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'stat-index'}" link v-if="profile.is_super_admin">
              <v-list-item-icon>
                <v-icon>mdi-guy-fawkes-mask</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Статистика</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </v-list>

        <template v-slot:append>
            <div class="pa-2">
                <v-btn text block @click="home">На главную</v-btn>
            </div>
            <div class="pa-2">
              <v-btn text block @click="logout">Выход</v-btn>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import {BUS} from "~/plugins/bus";
    import {API} from "~/plugins/axios";

    export default {
        name: "MainNavigationDrawer",

        data: () => ({
            drawer: true,
            profile: undefined
        }),

        created() {
            let self = this
            API.get('user/profile').then((data) => {
              self.profile = data.data
            })

            BUS.$on('drawer', () => {
                this.drawer = !this.drawer
            })
        },

        methods: {
            logout() {
                localStorage.removeItem('token');
                this.$router.push({name: 'home'})
            },
            home() {
              this.$router.push({name: 'home'})
            }
        }
    }
</script>

<style scoped>

</style>